export default [
  {
    path: '/admin/login-out',
    name: 'login-out',
    meta: { requiresAuth: true },
    component: () => import('@/pages/security/login-out/index.vue')
  }
]
